import { useState } from "react"
import { useNavigate } from "react-router-dom"
import routes from "../constants/routes"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import TabPanel from "../components/ui/TabPanel"
import { Stack } from "@mui/material"
import TabLogo from "../components/common/TabLogo"
import Assets from "../components/assets/Assets"
import Inventories from "../components/assets/Inventories"

const Asset = ({ tab }) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    navigate(newValue ? routes.ASSETS.INVENTORIES : routes.ASSETS.ASSETS, {
      replace: true,
    })
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Stack direction="row" sx={{ borderBottom: 1, borderColor: "divider" }}>
        <TabLogo />
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Assets" />
          <Tab label="Inventories" />
        </Tabs>
      </Stack>
      <TabPanel value={value} index={0}>
        <Assets />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Inventories />
      </TabPanel>
    </Box>
  )
}

export default Asset
